import { ButtonProps, CSSObject } from "@mui/material";
import colors from "theme/theme-light/colors";

const { text, background } = colors;
type ButtonVariantStyle = {
  props: Partial<ButtonProps>;
  style: CSSObject;
};
const variantGhost: ButtonVariantStyle[] = [
  {
    props: { variant: "ghost" },
    style: {
      backgroundColor: background.bgSecondary,
      color: text.textPrimary,
      "&:hover": {
        backgroundColor: background.bgSecondary,
      },
    },
  },
];

export default variantGhost;
